import { render, staticRenderFns } from "./ActivityCard.vue?vue&type=template&id=510ad97c&scoped=true&"
import script from "./ActivityCard.vue?vue&type=script&lang=js&"
export * from "./ActivityCard.vue?vue&type=script&lang=js&"
import style0 from "./ActivityCard.vue?vue&type=style&index=0&id=510ad97c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510ad97c",
  null
  
)

export default component.exports